module.exports = __webpack_public_path__ + "img/my-account-icon.f7e0366d.svg";